export const GET_WEBSTATS_HEAD = 'GET_WEBSTATS_HEAD';

export function getWebstatsHead(params) {
    return {
        type: GET_WEBSTATS_HEAD,
        request: {
            op: 'get',
            path: `/@getWebstatsHead`,
            params: params,
        },
    };
}
